import React, { useState, useEffect } from 'react';
import Valg from '../../Shared/Scripts/Models/Valg';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface NedbetalingstidOwnProps {
    id: string,
    collapsed: boolean,
    label: JSX.Element | null,
    locale: string,
    value: string | undefined,
    maxInput: number,
    minSlider: number,
    minAllowInput: string,
    posibleToSetZero: boolean,
    formatNumber: boolean,
    maxSlider: number,
    sliderStep: number,
    valuta?: string | null,
    onChangeHandler: any,
    aarUnder1Melding: JSX.Element | null
}

export function NedbetalingstidComponent (props: NedbetalingstidOwnProps): JSX.Element {
    const [belop, setBelop] = useState(props.value);
    
    useEffect(() => {
        updateLiveMessage();
    }, []);

    if(props.value !== undefined && belop !== undefined) {
        if(belop !== "" && parseInt(belop) !== parseInt(props.value)) {
            setBelop(props.value);
        }
    }

    function dispatch(value: string): void {
        let valg: number = parseInt(value);
        props.onChangeHandler(valg);
    }

    function inputHandler(e: React.SyntheticEvent<HTMLInputElement>): void {

        //kun tall er lov, fjerner alt annet. 
        let stringVal: string = e.currentTarget.value.replace(/[^0-9]/g,''); 
        let val: number = 0;

        if(stringVal === "") {
            setBelop("");
            return;
        }

        val = parseInt(stringVal.replace(/\s/g,''));

        if(val <= props.maxInput) {
            if(val === 0 && !props.posibleToSetZero) {
                setBelop(props.minAllowInput);
                dispatch(props.minAllowInput);
            } else {
                setBelop(stringVal.replace(/\s/g,''));
                dispatch(stringVal.replace(/\s/g,''));
            }
        }
    }

    function rangeHandler(e: React.SyntheticEvent<HTMLInputElement>) {
        if(e.currentTarget.value === "0" && !props.posibleToSetZero) {
            setBelop(props.minAllowInput);
            dispatch(props.minAllowInput);
        } else {
            setBelop(e.currentTarget.value);
            dispatch(e.currentTarget.value);
        }
    }

    function hentMeldingOmNedbetalingUnder1Aar(): JSX.Element | null {
        if(props.maxSlider === 0) {
            return <div className="c-veileder--mini-twocolumn-msg">{props.aarUnder1Melding}</div>
        }
        return null;
    }

    return (

        <div className={"c-veileder--mini-twocolumn-container"}>
            <label id={"c-veileder-betkalk-" + props.id} className="c-veileder__undersporsmal c-veileder--mini-twocolumn-first-item c-veileder--mini-twocolumn-item">
                {props.label}
            </label>
            <div className="c-veileder--mini-twocolumn-second-item c-veileder--mini-twocolumn-item">
                <div className="c-number-input c-number-input--big ">
                    <input disabled={props.collapsed} onInput={inputHandler} aria-labelledby={"c-veileder-betkalk-" + props.id} value={belop} onChange={() => {}}  className={"c-number-input__input "} type="text" />
                    <div className="c-range-input--postfix">
                        {props.valuta}
                    </div>
                </div>
                <div className="c-range-input">
                    <input disabled={props.collapsed} aria-labelledby={"c-veileder-betkalk-" + props.id} min={props.minSlider} max={props.maxSlider} step={props.sliderStep} onChange={rangeHandler} value={belop} type="range" className="c-range-input__input" />
                    <div className="c-range-input--postfix">
                        &nbsp;&nbsp;&nbsp;
                    </div>
                </div>
                {hentMeldingOmNedbetalingUnder1Aar()}
            </div>
        </div>
    );
};
